import script from "./SampleRoundDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./SampleRoundDetail.vue?vue&type=script&setup=true&lang=js"

import "./SampleRoundDetail.vue?vue&type=style&index=0&id=341b61da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-341b61da"]])

export default __exports__